import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=796a094e&scoped=true"
import script from "./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue?vue&type=script&lang=js"
import style0 from "./counter.vue?vue&type=style&index=0&id=796a094e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a094e",
  null
  
)

export default component.exports